import { ApiError } from '@eneco/dc/client/ApiError';

import { ErrorType } from './types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const generateErrorType = (e: any): ErrorType => {
  if (e instanceof ApiError) {
    if (e.firstError?.details?.toLowerCase().includes('file')) {
      // This is based on two common errors:
      // 1: incorrect file type:
      //  ApigeeCustomerInquiriesExtensions.GetCustomerInquiryMimeType received an file
      //  which is not a .pdf, and couldn't be processed as an image. Only Pdf, Jpeg, Jpg
      //  and Png are allowed
      // 2: file was rejected by file scanner (virus)
      //  ScanFile threw an expected statuscode {(int)statusCode} with expected response
      //  body having code <{error?.Code}> and detail <{error?.Detail}>
      return 'file';
    } else {
      return 'generic';
    }
  } else if (e instanceof ProgressEvent) {
    //This happens when the file could not be converted to base64 by the FileReader
    return 'file';
  }
  return 'generic';
};
